import React, { useState } from 'react';
import { NavBar } from '../components/SubscriptionAppNavBar';
import { Card } from '../components/SubscriptionAppCard';
import { Badge } from '../components/SubscriptionAppBadge';
import { Button } from '../components/SubscriptionAppButton';
import { Settings, ExternalLink, Info, AlertTriangle, CheckCircle2 } from 'lucide-react';
export function IntegrationsPage() {
  const [isStripeModalOpen, setIsStripeModalOpen] = useState(false);
  const [modalStep, setModalStep] = useState<'connect' | 'polling' | 'success' | 'rejected'>('connect');
  const [isStripeConnected, setIsStripeConnected] = useState(false);
  const [stripeTestMode, setStripeTestMode] = useState(false);
  const [stripeWarningTestMode, setStripeWarningTestMode] = useState(false);
  const openStripeModal = () => {
    setModalStep('connect');
    setIsStripeModalOpen(true);
  };
  const closeStripeModal = () => {
    setIsStripeModalOpen(false);
    setModalStep('connect');
  };
  const handleContinueToStripe = () => {
    setModalStep('polling');
    setTimeout(() => {
      // Randomly succeed or reject for demo purposes
      const isEligible = Math.random() > 0.5;
      setModalStep(isEligible ? 'success' : 'rejected');
    }, 2500);
  };
  const handleDone = () => {
    setIsStripeConnected(true);
    closeStripeModal();
  };
  return <div className="bg-[#F1F5F9] min-h-full p-4 md:p-6" data-id="element-8968" data-mp="397g8j08q7xm">
      {/* NavBar */}
      <div className="mb-4 md:mb-6" data-id="element-8969" data-mp="85o4dd7fwmap">
        <NavBar tabs={[]} title="Integrations" data-id="element-8970" data-mp="84ms55eottre" />
      </div>

      {/* Page Subtitle */}
      <div className="mb-4 md:mb-6" data-id="element-8971" data-mp="c6hrw5gyzz32">
        <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-8972" data-mp="gzavgq0pd1dk">
          Connect WinePik with your favorite tools and services
        </p>
      </div>

      {/* Single Column Layout */}
      <div className="max-w-6xl space-y-6 md:space-y-8" data-id="element-8973" data-mp="qx75fehwlqa3">
        {/* Section 1: Active Integrations */}
        <div data-id="element-8974" data-mp="vwbf068qpq0y">
          <div className="mb-3 md:mb-4" data-id="element-8975" data-mp="vvs59ct8u7y0">
            <h2 className="text-[18px] md:text-[20px] font-semibold text-[#0F172A] mb-1" data-id="element-8976" data-mp="vwtfxg6cksf7">
              Active Integrations
            </h2>
            <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-8977" data-mp="1930a4xayxn4">
              Currently connected to your WinePik account
            </p>
          </div>

          <div className="space-y-3 md:space-y-4" data-id="element-8978" data-mp="fzisi3o4z5us">
            {/* Shopify - Always Active */}
            <Card padding="lg" className="border border-[#E2E8F0]" data-id="element-8979" data-mp="b5obj7zx14ze">
              <div className="flex flex-col sm:flex-row items-start justify-between gap-4 sm:gap-6" data-id="element-8980" data-mp="oxuokl7ruvum">
                <div className="flex items-start gap-3 md:gap-4 flex-1 w-full" data-id="element-8981" data-mp="k0cgex1kwkno">
                  <div className="w-8 h-8 rounded-lg bg-[#95BF47] flex items-center justify-center flex-shrink-0" data-id="element-8982" data-mp="yxd6yx81a9kk">
                    <span className="text-white text-lg font-bold" data-id="element-8983" data-mp="txgzgo04o009">S</span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-8984" data-mp="30nexksixjrb9">
                    <div className="flex items-center gap-3 mb-1" data-id="element-8985" data-mp="30q1e3hnsth5m">
                      <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A]" data-id="element-8986" data-mp="2vqexcy8rhis2">
                        Shopify
                      </h3>
                      <Badge variant="success" data-id="element-8987" data-mp="1g5w7o43k7mwo">Connected</Badge>
                    </div>
                    <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-8988" data-mp="11h9hf7ce9aqo">
                      Core platform connection. Syncs products, customers, and
                      orders.
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto" data-id="element-8989" data-mp="sf098o4lltgg">
                  <button className="text-[13px] md:text-[14px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-8990" data-mp="wiy9j25ntab3">
                    View Details
                  </button>
                </div>
              </div>
            </Card>

            {/* Klaviyo */}
            <Card padding="lg" className="border border-[#E2E8F0]" data-id="element-8991" data-mp="2cw57rqkel0n2">
              <div className="flex flex-col sm:flex-row items-start justify-between gap-4 sm:gap-6" data-id="element-8992" data-mp="2hvhtg7zjg1o2">
                <div className="flex items-start gap-3 md:gap-4 flex-1 w-full" data-id="element-8993" data-mp="ht9vecpsguy1">
                  <div className="w-8 h-8 rounded-lg bg-[#000000] flex items-center justify-center flex-shrink-0" data-id="element-8994" data-mp="hr5t1z7jg3zv">
                    <span className="text-white text-lg font-bold" data-id="element-8995" data-mp="8sk4nnfdxur6">K</span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-8996" data-mp="3thawz4uvayi">
                    <div className="flex items-center gap-3 mb-1" data-id="element-8997" data-mp="3spejm3fp976">
                      <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A]" data-id="element-8998" data-mp="3v0bp7yokmbxj">
                        Klaviyo
                      </h3>
                      <Badge variant="success" data-id="element-8999" data-mp="3q7qt2qi6zmqu">Connected</Badge>
                    </div>
                    <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-9000" data-mp="3laif7242u4ve">
                      Email marketing automation and subscriber communications.
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto" data-id="element-9001" data-mp="3cb509tx6oo3a">
                  <Button variant="outline" size="sm" iconLeft={<Settings className="w-4 h-4" data-id="element-9003" data-mp="1msyea5eq9cnm" />} data-id="element-9002" data-mp="37caimvayd5kr">
                    Settings
                  </Button>
                  <button className="text-[13px] md:text-[14px] text-[#64748B] hover:text-[#0F172A] font-medium transition-colors" data-id="element-9004" data-mp="1rq6yebjfrqri">
                    Disconnect
                  </button>
                </div>
              </div>
            </Card>

            {/* Stripe — Interactive Card (toggles between Not Connected / Connected) */}
            <Card padding="lg" className="border border-[#E2E8F0]" data-id="element-9005" data-mp="13zkqqldcg8i1">
              <div className="flex flex-col sm:flex-row items-start justify-between gap-4 sm:gap-6" data-id="element-9006" data-mp="191ju3v9335ez">
                <div className="flex items-start gap-3 md:gap-4 flex-1 w-full" data-id="element-9007" data-mp="1d1ka3kbtzoo5">
                  <div className="w-8 h-8 rounded-lg bg-[#635BFF] flex items-center justify-center flex-shrink-0" data-id="element-9008" data-mp="1htc3s3qaaaii">
                    <span className="text-white text-lg font-bold" data-id="element-9009" data-mp="laeglmqm8p7u">S</span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-9010" data-mp="pbgfg2gmez9a">
                    <div className="flex items-center gap-3 mb-1" data-id="element-9011" data-mp="1snovo4rm8exq">
                      <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A]" data-id="element-9012" data-mp="1slucovzwmwwa">
                        Stripe
                      </h3>
                      {isStripeConnected && <Badge variant="success" data-id="element-9013" data-mp="22c6syc0os3wm">Connected</Badge>}
                      {isStripeConnected && stripeTestMode && <Badge variant="warning" data-id="element-9014" data-mp="1xfq7xqosa5nr">Test</Badge>}
                    </div>
                    <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-9015" data-mp="19pvrkz599yyr">
                      {isStripeConnected ? 'Yarra Valley Wines · acct_1Nx...K2aB' : 'Payment processing for admin-created subscriptions and migrations.'}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto" data-id="element-9016" data-mp="1emukjed6nzvd">
                  {isStripeConnected ? <>
                      {/* Test Mode Toggle */}
                      <label className="flex items-center gap-2 cursor-pointer select-none" data-id="element-9017" data-mp="2q3m2aoqvrlhd">
                        <span className="text-[13px] font-medium text-[#64748B]" data-id="element-9018" data-mp="2xm28ts3jtetk">
                          Test Mode
                        </span>
                        <button role="switch" aria-checked={stripeTestMode} onClick={() => setStripeTestMode(!stripeTestMode)} className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 ${stripeTestMode ? 'bg-[#F59E0B] focus:ring-[#F59E0B]/30' : 'bg-[#CBD5E1] focus:ring-[#0EA5E9]/30'}`} data-id="element-9019" data-mp="32mzsk947igx6">
                          <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow-sm transition-transform duration-200 ${stripeTestMode ? 'translate-x-[18px]' : 'translate-x-[3px]'}`} data-id="element-9020" data-mp="3lav03b986yhu" />
                        </button>
                      </label>
                      <button className="text-[13px] md:text-[14px] text-[#64748B] hover:text-[#0F172A] font-medium transition-colors" data-id="element-9021" data-mp="36b7usu1ykol">
                        Disconnect
                      </button>
                    </> : <Button variant="primary" size="sm" onClick={openStripeModal} data-id="element-9022" data-mp="240o5ywr3y883">
                      Connect
                    </Button>}
                </div>
              </div>
            </Card>

            {/* Stripe — Connected with Warning (Developer Reference) */}
            <Card padding="none" className="border border-[#E2E8F0]" data-id="element-9023" data-mp="1q99nqs50yb23">
              <div className="p-4 md:p-6" data-id="element-9024" data-mp="1q6wydtwxsyf0">
                <div className="flex flex-col sm:flex-row items-start justify-between gap-4 sm:gap-6" data-id="element-9025" data-mp="2mzsbhvjfxjv0">
                  <div className="flex items-start gap-3 md:gap-4 flex-1 w-full" data-id="element-9026" data-mp="2ixfblnrdkg65">
                    <div className="w-8 h-8 rounded-lg bg-[#635BFF] flex items-center justify-center flex-shrink-0" data-id="element-9027" data-mp="2dyc6k3bea9y6">
                      <span className="text-white text-lg font-bold" data-id="element-9028" data-mp="290ajz8erfshy">S</span>
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-9029" data-mp="12kgoomt3vn39">
                      <div className="flex items-center gap-3 mb-1" data-id="element-9030" data-mp="12h2n3gs9nhwv">
                        <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A]" data-id="element-9031" data-mp="xirdn75vv9f6">
                          Stripe
                        </h3>
                        <Badge variant="warning" data-id="element-9032" data-mp="seyyxsacjpjb">Action Required</Badge>
                        {stripeWarningTestMode && <Badge variant="warning" data-id="element-9033" data-mp="xe1r4c58a19v">Test</Badge>}
                      </div>
                      <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-9034" data-mp="1251qdo1tkvfj">
                        Yarra Valley Wines · acct_1Nx...K2aB
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto" data-id="element-9035" data-mp="1b56wzvz6vpsn">
                    {/* Test Mode Toggle */}
                    <label className="flex items-center gap-2 cursor-pointer select-none" data-id="element-9036" data-mp="1g5mbiqv7j3c7">
                      <span className="text-[13px] font-medium text-[#64748B]" data-id="element-9037" data-mp="1l3nr31tfckix">
                        Test Mode
                      </span>
                      <button role="switch" aria-checked={stripeWarningTestMode} onClick={() => setStripeWarningTestMode(!stripeWarningTestMode)} className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 ${stripeWarningTestMode ? 'bg-[#F59E0B] focus:ring-[#F59E0B]/30' : 'bg-[#CBD5E1] focus:ring-[#0EA5E9]/30'}`} data-id="element-9038" data-mp="3mvj17d018gz1">
                        <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow-sm transition-transform duration-200 ${stripeWarningTestMode ? 'translate-x-[18px]' : 'translate-x-[3px]'}`} data-id="element-9039" data-mp="27qgu0rdviwdw" />
                      </button>
                    </label>
                    <button className="text-[13px] md:text-[14px] text-[#64748B] hover:text-[#0F172A] font-medium transition-colors" data-id="element-9040" data-mp="2hms9fq8rg2ck">
                      Disconnect
                    </button>
                  </div>
                </div>
              </div>
              {/* Warning Bar */}
              <div className="border-t border-[#FDE68A] bg-[#FFFBEB] px-4 md:px-6 py-3 flex items-start gap-2.5 rounded-b-lg" data-id="element-9041" data-mp="2ve6r9tqxlxi1">
                <AlertTriangle className="w-4 h-4 text-[#D97706] flex-shrink-0 mt-0.5" data-id="element-9042" data-mp="3aj1fk69xcqke" />
                <p className="text-[13px] text-[#92400E]" data-id="element-9043" data-mp="35k7yy4zccjg0">
                  Stripe is not configured as a subscription gateway in Shopify.{' '}
                  <a href="#" className="font-medium text-[#D97706] hover:text-[#B45309] underline transition-colors" onClick={e => e.preventDefault()} data-id="element-9044" data-mp="30m6k5w8y76ac">
                    Configure in Shopify →
                  </a>
                </p>
              </div>
            </Card>
          </div>
        </div>

        {/* Section 2: Available Integrations */}
        <div data-id="element-9045" data-mp="3jjzliu3xb85m"></div>

        {/* Section 3: Coming Soon */}
        <div data-id="element-9046" data-mp="3jig2wwusol0o">
          <div className="mb-3 md:mb-4" data-id="element-9047" data-mp="3ji69t0egdxqr">
            <h2 className="text-[18px] md:text-[20px] font-semibold text-[#0F172A] mb-1" data-id="element-9048" data-mp="3fixis3assdyw">
              Coming Soon
            </h2>
            <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-9049" data-mp="fvpioxwmkx3i">
              Integrations on our roadmap
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-9050" data-mp="25c1kjabmwkg5">
            {/* Vinsight */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-9051" data-mp="2ab4o0qbyuim0">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-9052" data-mp="2ad7hjkcbutvh">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-9053" data-mp="1vlp0dj7qetaj">
                  <span className="text-white text-lg font-bold" data-id="element-9054" data-mp="20j8g6nk2ve4l">V</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-9055" data-mp="1mk8r5esnkx7w">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-9056" data-mp="1rl6ahupefxaz">
                    Vinsight
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-9057" data-mp="1cp70ufmn5p3q">
                    Winery inventory and production management
                  </p>
                  <Badge variant="default" data-id="element-9058" data-mp="372ggyq9p08uy">Coming Q3 2026</Badge>
                </div>
              </div>
            </Card>

            {/* InnoVint */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-9059" data-mp="3by41gsd8cdu4">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-9060" data-mp="10deik2qe7jg7">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-9061" data-mp="vfczviwvpm59">
                  <span className="text-white text-lg font-bold" data-id="element-9062" data-mp="1a491oy8ce2xf">I</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-9063" data-mp="15amw1q0lizb4">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-9064" data-mp="1j3cpgfigf6i9">
                    InnoVint
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-9065" data-mp="1f1hpbec9ez62">
                    Winery production and compliance software
                  </p>
                  <Badge variant="default" data-id="element-9066" data-mp="1o2fu3yuivapp">Coming Soon</Badge>
                </div>
              </div>
            </Card>

            {/* Tock */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-9067" data-mp="3uv9ir6mueof4">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-9068" data-mp="3pvn54w33r65s">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-9069" data-mp="3ra7qwagmjv2b">
                  <span className="text-white text-lg font-bold" data-id="element-9070" data-mp="3n26xe1kz8g">T</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-9071" data-mp="55chip8arz2c">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-9072" data-mp="a347vetand4f">
                    NowBookIt
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-9073" data-mp="38m2rff702w9b">
                    Cellar door reservations and hospitality
                  </p>
                  <Badge variant="default" data-id="element-9074" data-mp="3ij7fxlobj3ta">Coming Soon</Badge>
                </div>
              </div>
            </Card>

            {/* ShipCompliant / Sovos */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-9075" data-mp="3nbqtwjqx40ym">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-9076" data-mp="2ptqrez3tk72c">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-9077" data-mp="2usbgq3hj96c0">
                  <span className="text-white text-lg font-bold" data-id="element-9078" data-mp="1bwxlvmmtsvvu">SC</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-9079" data-mp="17xyiw7knn971">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-9080" data-mp="12xk8iivkzn5u">
                    ShipCompliant / Sovos
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-9081" data-mp="xxxtq503tyux">
                    US wine shipping compliance
                  </p>
                  <Badge variant="default" data-id="element-9082" data-mp="o8wfaj97jpj2">Coming Soon</Badge>
                </div>
              </div>
            </Card>

            {/* VinoShipper */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-9083" data-mp="k7aw6g62yf0f">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-9084" data-mp="f99cpu4qsdof">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-9085" data-mp="a94vg1w0fex5">
                  <span className="text-white text-lg font-bold" data-id="element-9086" data-mp="5atlzs9mn6fg">VS</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-9087" data-mp="3rqiud5q6mgto">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-9088" data-mp="3rtwz2kmbj24a">
                    VinoShipper
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-9089" data-mp="3irxfbkjx5jxn">
                    US DTC wine shipping and permits
                  </p>
                  <Badge variant="default" data-id="element-9090" data-mp="ecnv672c781o">Coming Soon</Badge>
                </div>
              </div>
            </Card>
          </div>
        </div>

        {/* Section 4: Recommended Shopify Apps */}
        <div data-id="element-9091" data-mp="5kc54mb4xmm8">
          <div className="mb-3 md:mb-4" data-id="element-9092" data-mp="5kvpsas66p3y">
            <h2 className="text-[18px] md:text-[20px] font-semibold text-[#0F172A] mb-1" data-id="element-9093" data-mp="5judk2zf3wkn">
              Recommended Shopify Apps
            </h2>
            <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-9094" data-mp="xbs31ci56vrr">
              These apps work great alongside WinePik
            </p>
          </div>

          <div className="bg-[#E0F2FE] border border-[#BAE6FD] rounded-lg p-3 md:p-4 mb-3 md:mb-4 flex items-start gap-3" data-id="element-9095" data-mp="123t9uiwjjuae">
            <Info className="w-5 h-5 text-[#0284C7] flex-shrink-0 mt-0.5" data-id="element-9096" data-mp="2mqaubyjf3er4" />
            <p className="text-[13px] md:text-[14px] text-[#0284C7]" data-id="element-9097" data-mp="2ht16uofl9d5x">
              These are third-party Shopify apps. Install them directly from
              Shopify - no WinePik setup required.
            </p>
          </div>

          {/* App Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-9098" data-mp="23szxslp66zfd">
            {/* Shippit */}
            <Card padding="md" className="border border-[#E2E8F0]" data-id="element-9099" data-mp="1yvhubatx9cer">
              <div className="flex items-start gap-3 mb-3" data-id="element-9100" data-mp="2drz4vzuaen09">
                <div className="w-6 h-6 rounded bg-[#00B67A] flex items-center justify-center flex-shrink-0" data-id="element-9101" data-mp="2dtabe7f4a8v2">
                  <span className="text-white text-sm font-bold" data-id="element-9102" data-mp="28uz0rugzzubs">S</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-9103" data-mp="3p5b6e42kqtj9">
                  <h3 className="text-[13px] md:text-[14px] font-semibold text-[#0F172A] mb-1" data-id="element-9104" data-mp="3k8krvl6f45zy">
                    Shippit
                  </h3>
                  <p className="text-[12px] md:text-[13px] text-[#64748B]" data-id="element-9105" data-mp="1hn78g1e2xegh">
                    Multi-carrier shipping for Australia
                  </p>
                </div>
              </div>
              <a href="https://apps.shopify.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[12px] md:text-[13px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-9106" data-mp="1ri8x6w4g0eij">
                View in App Store
                <ExternalLink className="w-3 h-3" data-id="element-9107" data-mp="25a6zoo3nfc5q" />
              </a>
            </Card>

            {/* Starshipit */}
            <Card padding="md" className="border border-[#E2E8F0]" data-id="element-9108" data-mp="2abctyqcyj7hd">
              <div className="flex items-start gap-3 mb-3" data-id="element-9109" data-mp="2f9o3t1395hzl">
                <div className="w-6 h-6 rounded bg-[#FF6B35] flex items-center justify-center flex-shrink-0" data-id="element-9110" data-mp="2f71uox0pquf9">
                  <span className="text-white text-sm font-bold" data-id="element-9111" data-mp="kv3nt1pvmamj">C</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-9112" data-mp="kwy94h5284r5">
                  <h3 className="text-[13px] md:text-[14px] font-semibold text-[#0F172A] mb-1" data-id="element-9113" data-mp="dcnmccs2f7h7">
                    Corkship
                  </h3>
                  <p className="text-[12px] md:text-[13px] text-[#64748B]" data-id="element-9114" data-mp="8j17cdyfiri8">
                    eParcel for Australian wineries
                  </p>
                </div>
              </div>
              <a href="https://apps.shopify.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[12px] md:text-[13px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-9115" data-mp="3upzkdm0u0f5e">
                View in App Store
                <ExternalLink className="w-3 h-3" data-id="element-9116" data-mp="mazbsbh73z82" />
              </a>
            </Card>

            {/* ShipStation */}
            <Card padding="md" className="border border-[#E2E8F0]" data-id="element-9117" data-mp="hcxt3rnom1x4">
              <div className="flex items-start gap-3 mb-3" data-id="element-9118" data-mp="373kne9i0g3nm">
                <div className="w-6 h-6 rounded bg-[#3B5998] flex items-center justify-center flex-shrink-0" data-id="element-9119" data-mp="323er2g0spsz7">
                  <span className="text-white text-sm font-bold" data-id="element-9120" data-mp="21vo1iciii8j3">SS</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-9121" data-mp="1x5hdoevtqs1w">
                  <h3 className="text-[13px] md:text-[14px] font-semibold text-[#0F172A] mb-1" data-id="element-9122" data-mp="1x3msczgn4xxa">
                    ShipStation
                  </h3>
                  <p className="text-[12px] md:text-[13px] text-[#64748B]" data-id="element-9123" data-mp="1n7bew65be219">
                    Global multi-carrier shipping
                  </p>
                </div>
              </div>
              <a href="https://apps.shopify.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[12px] md:text-[13px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-9124" data-mp="2fvpc4jokwubr">
                View in App Store
                <ExternalLink className="w-3 h-3" data-id="element-9125" data-mp="26uhcnyabtng3" />
              </a>
            </Card>
          </div>
        </div>
      </div>

      {/* Stripe Connect Modal */}
      {isStripeModalOpen && <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-[rgba(15,23,42,0.5)] z-[1040] animate-[ocean-fade-in_200ms_ease-in-out]" onClick={closeStripeModal} data-id="element-9126" data-mp="vi89gn1oyln1" />

          {/* Modal */}
          <div className="fixed inset-0 flex items-center justify-center z-[1050] p-4" data-id="element-9127" data-mp="3b5c3falyhbho">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-[480px] animate-[ocean-scale-in_200ms_ease-in-out]" onClick={e => e.stopPropagation()} data-id="element-9128" data-mp="3g33vq5qiizme">
              <div className="p-8" data-id="element-9129" data-mp="3ptyta697lln5">
                {modalStep === 'connect' && <div className="animate-[ocean-fade-in_200ms_ease-in-out]" data-id="element-9130" data-mp="3pvt4utylc1ek">
                    {/* Stripe Icon */}
                    <div className="flex justify-center mb-6" data-id="element-9131" data-mp="2ozh2df9122y">
                      <div className="w-14 h-14 rounded-2xl bg-[#635BFF] flex items-center justify-center" data-id="element-9132" data-mp="2pimiunppy03">
                        <span className="text-white text-2xl font-bold" data-id="element-9133" data-mp="7napqktt56jl">S</span>
                      </div>
                    </div>

                    {/* Heading */}
                    <h2 className="text-[20px] font-semibold text-[#0F172A] text-center mb-2" data-id="element-9134" data-mp="29gi2bmi1da1s">
                      Connect your Stripe account
                    </h2>

                    {/* Body */}
                    <p className="text-[14px] text-[#64748B] text-center mb-6 leading-relaxed" data-id="element-9135" data-mp="37sl08z8nifkt">
                      You'll be redirected to Stripe to authorise WinePik to
                      access your account. This allows WinePik to securely
                      collect payment methods for your subscriptions.
                    </p>

                    {/* Bullet Points */}
                    <div className="space-y-3 mb-8" data-id="element-9136" data-mp="3qqx9sm3h5rgx">
                      <div className="flex items-start gap-3" data-id="element-9137" data-mp="3qob3epsbli0a">
                        <CheckCircle2 className="w-5 h-5 text-[#10B981] flex-shrink-0 mt-0.5" data-id="element-9138" data-mp="8auv4nvlckhu" />
                        <span className="text-[14px] text-[#0F172A]" data-id="element-9139" data-mp="4budv9srhpwy">
                          Securely collect card details for subscriptions
                        </span>
                      </div>
                      <div className="flex items-start gap-3" data-id="element-9140" data-mp="dck3twvccm2r">
                        <CheckCircle2 className="w-5 h-5 text-[#10B981] flex-shrink-0 mt-0.5" data-id="element-9141" data-mp="wwho8724lhe3" />
                        <span className="text-[14px] text-[#0F172A]" data-id="element-9142" data-mp="11vucmw8nawis">
                          Import existing payment methods for migrations
                        </span>
                      </div>
                    </div>

                    {/* Primary CTA */}
                    <button onClick={handleContinueToStripe} className="w-full h-12 bg-[#0EA5E9] text-white text-[14px] font-medium rounded-md hover:bg-[#0284C7] active:bg-[#0369A1] focus:outline-none focus:ring-[3px] focus:ring-[#0EA5E9]/20 transition-all duration-200" data-id="element-9143" data-mp="s00zpbr0l10h">
                      Continue to Stripe →
                    </button>

                    {/* Cancel */}
                    <div className="text-center mt-4" data-id="element-9144" data-mp="97yctins4ohs">
                      <button onClick={closeStripeModal} className="text-[14px] text-[#94A3B8] hover:text-[#64748B] font-medium transition-colors" data-id="element-9145" data-mp="3rcjkw4j9ei98">
                        Cancel
                      </button>
                    </div>
                  </div>}

                {modalStep === 'polling' && <div className="animate-[ocean-fade-in_200ms_ease-in-out] py-4" data-id="element-9146" data-mp="3jcnaz5x3yy08">
                    {/* Spinner */}
                    <div className="flex justify-center mb-6" data-id="element-9147" data-mp="3ekvj8s27um8i">
                      <div className="relative w-14 h-14" data-id="element-9148" data-mp="3ejaop2fwj3an">
                        <div className="absolute inset-0 border-[3px] border-[#E0F2FE] rounded-full" data-id="element-9149" data-mp="39lsl7rknlga1"></div>
                        <div className="absolute inset-0 border-[3px] border-[#0EA5E9] rounded-full border-t-transparent animate-spin" data-id="element-9150" data-mp="35mjukvkwtyip"></div>
                      </div>
                    </div>

                    {/* Heading */}
                    <h2 className="text-[20px] font-semibold text-[#0F172A] text-center mb-2" data-id="element-9151" data-mp="2vom6c831w1q3">
                      Verifying eligibility
                    </h2>

                    {/* Body */}
                    <p className="text-[14px] text-[#64748B] text-center leading-relaxed" data-id="element-9152" data-mp="tt22g2n6cbi6">
                      We are confirming your store is eligible for legacy
                      gateway access.
                    </p>

                    {/* Helper text */}
                    <p className="text-[13px] text-[#94A3B8] text-center mt-4" data-id="element-9153" data-mp="11de3w74qoioq">
                      This usually takes a few seconds. Please don't close this
                      window.
                    </p>
                  </div>}

                {modalStep === 'success' && <div className="animate-[ocean-fade-in_200ms_ease-in-out]" data-id="element-9154" data-mp="ef9fxqxuc6fc">
                    {/* Success Icon */}
                    <div className="flex justify-center mb-6" data-id="element-9155" data-mp="igunqxvipuio">
                      <div className="w-14 h-14 rounded-full bg-[#D1FAE5] flex items-center justify-center" data-id="element-9156" data-mp="nffoqzilgi86">
                        <CheckCircle2 className="w-8 h-8 text-[#10B981]" data-id="element-9157" data-mp="sesept4ri5ez" />
                      </div>
                    </div>

                    {/* Heading */}
                    <h2 className="text-[20px] font-semibold text-[#0F172A] text-center mb-2" data-id="element-9158" data-mp="1ywp71ipzl47w">
                      Stripe account connected
                    </h2>

                    {/* Body */}
                    <p className="text-[14px] text-[#64748B] text-center mb-8 leading-relaxed" data-id="element-9159" data-mp="1e73i4yxdznst">
                      Yarra Valley Wines (acct_1Nx...K2aB) has been successfully
                      connected to WinePik.
                    </p>

                    {/* Done CTA */}
                    <button onClick={handleDone} className="w-full h-12 bg-[#0EA5E9] text-white text-[14px] font-medium rounded-md hover:bg-[#0284C7] active:bg-[#0369A1] focus:outline-none focus:ring-[3px] focus:ring-[#0EA5E9]/20 transition-all duration-200" data-id="element-9160" data-mp="1j5517jutbn4a">
                      Done
                    </button>
                  </div>}

                {modalStep === 'rejected' && <div className="animate-[ocean-fade-in_200ms_ease-in-out]" data-id="element-9161" data-mp="10cu98l1p59ky">
                    {/* Error Icon */}
                    <div className="flex justify-center mb-6" data-id="element-9162" data-mp="cmq9iormptz8">
                      <div className="w-14 h-14 rounded-full bg-[#FEE2E2] flex items-center justify-center" data-id="element-9163" data-mp="7pzv05vh36fx">
                        <AlertTriangle className="w-7 h-7 text-[#EF4444]" data-id="element-9164" data-mp="2jbihjnlz2a7r" />
                      </div>
                    </div>

                    {/* Heading */}
                    <h2 className="text-[20px] font-semibold text-[#0F172A] text-center mb-2" data-id="element-9165" data-mp="29edqb9d9rok3">
                      Store not eligible
                    </h2>

                    {/* Body */}
                    <p className="text-[14px] text-[#64748B] text-center mb-6 leading-relaxed" data-id="element-9166" data-mp="3231ilowfre75">
                      We weren't able to verify your store for legacy gateway
                      access. This usually means your Shopify plan or region
                      doesn't support the legacy gateway.
                    </p>

                    {/* Reason box */}
                    <div className="bg-[#FEF2F2] border border-[#FECACA] rounded-md p-3 mb-6 flex items-start gap-2" data-id="element-9167" data-mp="2x2582shkwtsr">
                      <Info className="w-4 h-4 text-[#EF4444] flex-shrink-0 mt-0.5" data-id="element-9168" data-mp="1hpkcfiacando" />
                      <p className="text-[13px] text-[#991B1B] leading-relaxed" data-id="element-9169" data-mp="1lmovnmcz6nzz">
                        Contact support if you believe this is an error, or try
                        again later.
                      </p>
                    </div>

                    {/* Retry CTA */}
                    <button onClick={handleContinueToStripe} className="w-full h-12 bg-[#0EA5E9] text-white text-[14px] font-medium rounded-md hover:bg-[#0284C7] active:bg-[#0369A1] focus:outline-none focus:ring-[3px] focus:ring-[#0EA5E9]/20 transition-all duration-200" data-id="element-9170" data-mp="24by2uzr5mt0r">
                      Try again
                    </button>

                    {/* Cancel */}
                    <div className="text-center mt-4" data-id="element-9171" data-mp="2n9iirhbxyh98">
                      <button onClick={closeStripeModal} className="text-[14px] text-[#94A3B8] hover:text-[#64748B] font-medium transition-colors" data-id="element-9172" data-mp="2ibh02xifgjya">
                        Cancel
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </>}
    </div>;
}